import { List, ListItem, ListItemText } from '@mui/material'

import React from 'react'
import { Single } from 'infrastructure/api'
import { transformFeaturesIntoPackages } from '../../utility/utils'

export function FeaturesPackagesList({
  platformFeatures = [],
  childrenForFeaturePackage,
}: {
  platformFeatures: Single.PlatformFeature[]
  childrenForFeaturePackage?: (f: string) => any
}) {
  const matchedFeaturePackages = transformFeaturesIntoPackages(platformFeatures)

  if (matchedFeaturePackages.length === 0) {
    return <></>
  }
  return (
    <List>
      {matchedFeaturePackages.map(([packageName, packageFeatures]: any) => {
        return packageFeatures.length > 0 ? (
          <div key={packageName}>
            <h3>{packageName}</h3>
            {packageFeatures.map((feature: any) => {
              return (
                <ListItem key={feature.id} alignItems="flex-start">
                  <ListItemText
                    primary={feature.name}
                    secondary={`FreeTrial: ${!!feature.free_trial}, Locked: ${!!feature.locked}`}
                  />
                </ListItem>
              )
            })}
            {childrenForFeaturePackage?.(packageName)}
          </div>
        ) : null
      })}
    </List>
  )
}
